module.exports = __webpack_public_path__ + "img/WithAPIKey.469fb2e7.svg";